import {
  type FilterProvider,
  type FilterProviderOptions,
  FilterProviderType,
  type SuppliedFilterProviderOptions,
  type ValueRowProps,
  type FilterKey,
  type IndexedBlockValueItem,
  type FilterBlock,
} from '../types'
import {defaultFilterProviderOptions} from '../constants/defaults'
import {FILTER_KEYS} from '../constants/filter-constants'
import {capitalize} from '../utils'
import type {Icon} from '@primer/octicons-react'
import type {FilterQuery} from '../filter-query'

export class KeyOnlyFilterProvider implements FilterProvider {
  key: string
  displayName: string
  description?: string
  priority: number
  type = FilterProviderType.Text
  icon: Icon
  options: FilterProviderOptions

  constructor(filterKey: FilterKey, options?: SuppliedFilterProviderOptions) {
    Object.assign(this, filterKey)
    this.displayName = filterKey.displayName ?? capitalize(filterKey.key)
    this.options = {
      ...defaultFilterProviderOptions,
      ...options,
      filterTypes: {
        ...defaultFilterProviderOptions.filterTypes,
        multiValue: false,
        valueless: false,
        ...options?.filterTypes,
      },
    }
    this.priority = this.options.priority
  }

  async getSuggestions() {
    return null
  }

  async validateFilterBlockValues(
    filterQuery: FilterQuery,
    block: FilterBlock,
    values: IndexedBlockValueItem[],
  ): Promise<IndexedBlockValueItem[]> {
    return values.map(value => {
      return {
        ...value,
        valid: true,
      }
    })
  }

  getValueRowProps(): ValueRowProps {
    return {text: ''}
  }
}

export class BaseFilterProvider extends KeyOnlyFilterProvider {
  constructor(options?: SuppliedFilterProviderOptions) {
    super(FILTER_KEYS.base, options)
  }
}

export class HeadFilterProvider extends KeyOnlyFilterProvider {
  constructor(options?: SuppliedFilterProviderOptions) {
    super(FILTER_KEYS.head, options)
  }
}

export class InBodyFilterProvider extends KeyOnlyFilterProvider {
  constructor(options?: SuppliedFilterProviderOptions) {
    super(FILTER_KEYS.inBody, options)
  }
}

export class InCommentsFilterProvider extends KeyOnlyFilterProvider {
  constructor(options?: SuppliedFilterProviderOptions) {
    super(FILTER_KEYS.inComments, options)
  }
}

export class InTitleFilterProvider extends KeyOnlyFilterProvider {
  constructor(options?: SuppliedFilterProviderOptions) {
    super(FILTER_KEYS.inTitle, options)
  }
}

export class ShaFilterProvider extends KeyOnlyFilterProvider {
  constructor(options?: SuppliedFilterProviderOptions) {
    super(FILTER_KEYS.sha, options)
  }
}
